import Communication from '@/model/Communication';
import api from '@/services/api';

export const communicationService = {
  async create(payload: Communication): Promise<Communication> {
    const { data } = await api.post<Communication>('/communication', payload);
    return data;
  },

  async list(): Promise<Communication[]> {
    const { data } = await api.get<Communication[]>('/communication');
    return data;
  },

  async findById(id: string): Promise<Communication> {
    const { data } = await api.get<Communication>(`/communication/${id}`);
    return data;
  },

  async update(id: string, payload: Communication): Promise<Communication> {
    const { data } = await api.put<Communication>(`/communication/${id}`, payload);
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.post(`/communication/${id}/delete`);
  },
};
